import gameImage from "../assets/masterThesis/game.webp";
import dashboardImage from "../assets/masterThesis/dashboard.webp";
import systemImage from "../assets/masterThesis/system.webp";

import bubble1 from "../assets/bubbleBobble/bubbleBobble1.webp";
import bubble2 from "../assets/bubbleBobble/bubbleBobble2.webp";

import learn1 from "../assets/learningPlatform/learnPlatform1.webp";
import learn2 from "../assets/learningPlatform/learnPlatform2.webp";

import maze1 from "../assets/maze/maze1.webp";
import maze2 from "../assets/maze/maze2.webp";
import maze3 from "../assets/maze/maze3.webp";

import vrGame1 from "../assets/vrGame/vrGame1.webp";
import vrGame2 from "../assets/vrGame/vrGame2.webp";
import vrGame3 from "../assets/vrGame/vrGame3.webp";

import virusGame1 from "../assets/virusGame/virusGame1.webp";
import virusGame2 from "../assets/virusGame/virusGame2.webp";

export interface Project {
    title: string;
    description: string;
    mediaUrls: string[];
    link?: string;
}

export const projects: Project[] = [
    {
        title: "Master Thesis",
        description: "\"Analysing The Impact of Learning Analytics Dashboards in a Game-Based Learning System for Sorting Algorithms\" \n I developed a DGBL system featuring a serious game for sorting algorithms and a teacher-support dashboard, both built in Unity and connected via Unity Lobby Service. Using the adlete framework, an adaptive, competence-based environment, the system tracks learner data to personalize tasks.",
        mediaUrls: [gameImage, dashboardImage, systemImage, "https://8ydu6usooiqqvpjd.public.blob.vercel-storage.com/game.mp4", "https://8ydu6usooiqqvpjd.public.blob.vercel-storage.com/dashboard.mp4"],
        link: "https://github.com/vdrongow/Master-Project-Game"
    },
    {
        title: "Bubble Bobble reloaded",
        description: "As part of a collaborative practice project at University, we worked in a team of six to create a massively multiplayer game that reinvented an existing classic, Bubble Bobble. Each developer was responsible for a part of the development. My focus was on developing and implementing the bots, whose autonomous behavior is modelled in a decision tree.",
        mediaUrls: [bubble1, bubble2, "https://8ydu6usooiqqvpjd.public.blob.vercel-storage.com/bubbleBobble1.mp4", "https://8ydu6usooiqqvpjd.public.blob.vercel-storage.com/bubbleBobble2.mp4"],
        link: "https://github.com/m2-retro-mmo/bubble-bobble"
    },
    {
        title: "Interactive Learning Platform",
        description: "Using Figma, I developed a high-fidelity prototype of a dynamic learning platform that was usability tested.",
        mediaUrls: [learn1, learn2],
        link: "https://www.figma.com/proto/jS7m432hHHVeuQhXEO9B0x/App?node-id=0-1&t=uVj0dAzOygj7xMkc-1"
    },
    {
        title: "Animted Film",
        description: "Using Procreate Dreams and Davinci resolve, I created an animated film about a squirrel alone in the forest. As he hunts for food, he gets scarred with bright spots that look like eyes. But when he starts to move, all the eyes turn out to be fireflies.",
        mediaUrls: ["https://8ydu6usooiqqvpjd.public.blob.vercel-storage.com/GlowingTrails.mp4"],
    },
    {
        title: "Generate 3D mazes with Unity's ML Agents",
        description: "An intelligent agent capable of creating a valid maze on the surface of a cube was trained using the Unity ML Agents Toolkit.",
        mediaUrls: [maze1, maze2, maze3],
        link: "https://github.com/fayebullwinkel/fifi-ml-agents"
    },
    {
        title: "Two Player VR Game",
        description: "In a collaborative practice project at university, we developed a multimodal game that requires non-verbal communication between a PC player and a VR player. We created a scenario where the VR player is teleported to a lonely planet to repair a broken antenna. The PC player stays behind on the spaceship to monitor the other player's activities and retrieve important information from the ship's computer.",
        mediaUrls: [vrGame1, vrGame2, vrGame3],
        link: "https://github.com/Master-project-Interaktion-in-VR/Project_InteractionInVR"
    },
    {
        title: "Incremental Game",
        description: "I developed an incremental game with Unity. The goal of the game is to infect the population of the earth with a new, unknown virus. The player is the virus and wants to infect as many people as possible.",
        mediaUrls: [virusGame1, virusGame2],
    },
];
